import React, { Children } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

type ActiveLinkPropsType = {
    activeClassName?: string;
    href?: string;
    as?: string;
    onClick?: any;
};

const ActiveLink: React.FC<React.PropsWithChildren<ActiveLinkPropsType>> = ({
    children,
    activeClassName = '',
    href,
    as,
    onClick,
    ...props
}) => {
    const router = useRouter();
    const child = Children.only(children) as React.ReactElement;
    const childClassName = (child && child.props.className) || '';
    const childHref: string = (child && child.props.href) || href || '/safety-centre';

    const onClickHandler = (event: React.SyntheticEvent) => {
        event.preventDefault();

        onClick();

        router.push(childHref);
    };

    // pages/index.js will be matched via props.href
    // pages/about.js will be matched via props.href
    // pages/[slug].js will be matched via props.as
    const className =
        router.asPath === childHref || router.asPath === as
            ? `${childClassName} ${activeClassName}`.trim()
            : childClassName;

    const content = React.cloneElement(child, {
        className: className || null,
    });
    return onClick ? (
        <button onClick={onClickHandler}>{content}</button>
    ) : (
        <Link href={childHref} legacyBehavior {...props}>
            {content}
        </Link>
    );
};

export default ActiveLink;
